module.exports = "<h3 ng-if=\"!$ctrl.model.id\">Nuevo Tramite</h3>\n<h3 ng-if=\"$ctrl.model.id\">Tramite #{{$ctrl.model.id}}</h3>\n"